/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import { B300 } from '@atlaskit/theme/colors';
import { spacing } from '../constants';
import { HALF_GRID_SIZE, LABEL_TOP_SPACING, PROGRESS_BAR_HEIGHT, varSpacing, varTransitionDelay, varTransitionEasing, varTransitionSpeed } from './constants';
var progressBarStyles = css({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  height: PROGRESS_BAR_HEIGHT,
  position: 'absolute',
  backgroundColor: "var(--ds-background-brand-bold, ".concat(B300, ")"),
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  borderEndEndRadius: PROGRESS_BAR_HEIGHT,
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  borderStartEndRadius: PROGRESS_BAR_HEIGHT,
  insetInlineStart: '50%',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  transform: "translate(0, calc(-1 * ".concat(LABEL_TOP_SPACING, "))"),
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  transition: "width var(".concat(varTransitionSpeed, ") var(").concat(varTransitionEasing, ")"),
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  transitionDelay: "var(".concat(varTransitionDelay, ")")
});

/**
 * __Progress bar__
 *
 * A progress bar describes the horizontal tracking bar that traverses each individual step.
 *
 */
var ProgressBar = function ProgressBar(_ref) {
  var percentageComplete = _ref.percentageComplete,
    testId = _ref.testId;
  return jsx("div", {
    "data-testid": testId,
    style: {
      width: "calc(".concat(percentageComplete, "% + ").concat(percentageComplete / 100
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
      , " * calc(var(").concat(varSpacing, ", ").concat(spacing.cosy, ") + ").concat(HALF_GRID_SIZE, "))")
    },
    css: progressBarStyles
  });
};
export default ProgressBar;